import React, { useEffect, useRef, useState } from 'react';
import { Icon, Tooltip } from 'antd';
import styles from './EmailSubscription.module.less';

type PropsEmailSubscriptionItem = {
  email: string;
  onRemove: () => void;
};

export const EmailSubscriptionItem: React.FC<PropsEmailSubscriptionItem> = ({ email, onRemove }) => {
  const tooltip = useRef<HTMLDivElement>(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    if (tooltip.current) {
      setTooltipVisible(tooltip.current.clientWidth < tooltip.current.scrollWidth);
    }
  }, []);

  return (
    <div className={styles.subscriptionsItem} key={email}>
      <div ref={tooltip}>
        {tooltipVisible ? (
          <Tooltip title={email}>
            {email}
          </Tooltip>
        ) : (
          email
        )}
      </div>
      <Icon type="close" className={styles.closeIcon} onClick={() => onRemove()} />
    </div>
  );
};
